import React from 'react';
import { Outlet } from 'react-router';
import Footer from '@@components/Footer/Footer';
import Header from '@@components/Header/Header';
import NotificationCarousel from '@@components/NotificationCarousel/NotificationCarousel';
import { LocaleProvider } from '@@providers/LocaleProvider';
// import Related from '@@components/Related/Related';

const Root: React.FC = () => {
    return (
        <LocaleProvider>
            <NotificationCarousel />
            <Header />
            <Outlet />
            {/* <Related /> */}
            <Footer />
        </LocaleProvider>
    );
};

export default Root;
